<p8-layout-settings-page>
  <mat-card>
    <mat-card-title>
      <p8-layout-settings-header [titlePath]="['Historique de vos demandes de consultation d\'archives']"
                                 [iconRacine]="'find_in_page'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-subtitle>
      Cet espace vous permet d'accéder à la liste de vos demandes de consultations d'archives et à leur suivi
    </mat-card-subtitle>
    <mat-card-content fxLayout="column">
      <div style="padding-bottom: 5px" fxFlexAlign="end">
        <div fxLayout="column">
          <button color="accent" mat-raised-button (click)="addConsultation()" routerLinkActive="true"
                  matTooltip="Cliquer pour saisir votre demande de consultation d'archive" data-cy="btn-my-deposit-add">
            <mat-icon>add</mat-icon>
            NOUVELLE DEMANDE DE CONSULTATION
          </button>
        </div>
      </div>
      <div>
        <app-data-table
          [dataSource]="dsLoaning"
          [extraParams]="extraParams"
          [urlBaseOverride]="urlList"
          [refreshButton]="false"
          [refreshIcone]="true"
          [filterDisplay]="true"
          [placeHolderFilter]="'Recherche de demandes de consultation'"
          [toolTipFilter]="'Recherche de demandes de consultation'"
          [flexAction]="5" [flexColumn]="90"
          [pageSize]="10" [pageSizesList]="[5,10,25]"
          [columns]="columns" [actions]="actions"
          [showFirstLastButtons]="true"
          [showLoader]="true">
        </app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</p8-layout-settings-page>
